module.exports = __webpack_public_path__ + "img/hera.dcb1dd7e.svg";